import { defineMessages } from 'react-intl';

export default defineMessages({
    assignClasses: {
        id: 'app.components.StudentClassDetail.assignClasses',
        defaultMessage: 'Assign Class(es)'
    },
    classDetails: {
        id: 'app.components.StudentClassDetail.classDetails',
        defaultMessage: 'Class details'
    }
});



// WEBPACK FOOTER //
// ./app/components/student-class-detail/messages.js